import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { TranslateStage } from '../translate-stage';
import { TranslateServerSideModel } from '../../models/translate-server-side-model';
import { TranslateStep } from '../../types';
import { RavenService } from '@telecom/shared/services/raven-service/raven-service';
import * as TrackEvents from '@/constants/track-events';
import { GetTranslateServerSideStateService } from '../get-translate-task-status-service';
import { CurrentTaskService } from '@/services/current-task/current-task-service';
import { TRACK_EVENT_TYPE } from '@/constants';

@injectable()
export class TranslateStagePreview implements TranslateStage {
    constructor(
        @inject(RavenService)
        private readonly _ravenService: RavenService,
        @inject(GetTranslateServerSideStateService)
        private readonly _getTranslateServerSideStateService: GetTranslateServerSideStateService,
        @inject(CurrentTaskService)
        private readonly _currentTaskService: CurrentTaskService,
    ) {}

    isPreviousStage(): boolean {
        return false;
    }

    isCurrentStage(model: TranslateServerSideModel): boolean {
        return model.modelData.currentStep === TranslateStep.StepPreview;
    }

    onLeave(): Promise<void> {
        const taskId = this._currentTaskService.taskId;
        this._ravenService.track(TrackEvents.TRACK_EVENT_LEAVE_TRANSLATION_PREVIEW, {
            eventType: TRACK_EVENT_TYPE.Translation,
            otherParam: taskId,
        });
        return Promise.resolve();
    }

    isNextStage(model: TranslateServerSideModel): boolean {
        return model.modelData.currentStep === TranslateStep.StepResult;
    }

    async onEnter(model: TranslateServerSideModel): Promise<void> {
        const taskId = this._currentTaskService.taskId;
        this._ravenService.track(TrackEvents.TRACK_EVENT_ENTER_TRANSLATION_PREVIEW, {
            eventType: TRACK_EVENT_TYPE.Translation,
            otherParam: taskId,
        });
        await this._getTranslateServerSideStateService.pullTranslateServerSideState(taskId);
        model.update(states => {
            states.currentStep = TranslateStep.StepPreview;
            return states;
        });
    }
}
